var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobalLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5a.75.75 0 01.75.75v1a.75.75 0 01-1.5 0v-1A.75.75 0 016 8.5z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0a3.5 3.5 0 013.5 3.5v2h.5l.204.01A2 2 0 0112 7.5v5a2 2 0 01-1.796 1.99L10 14.5H2a2 2 0 01-1.99-1.796L0 12.5v-5a2 2 0 012-2h.5v-2A3.5 3.5 0 016 0zM2 7a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-5A.5.5 0 0010 7H2zm4-5.5a2 2 0 00-2 2v2h4v-2a2 2 0 00-2-2z",
    fill: "#000"
  })));
}
export default SvgIconGlobalLocked;